<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <h3 class="">Pausando atención</h3>
        <h6>Seleccione el motivo para la pausa a realizar</h6>
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">
            <form [formGroup]="motivosForm" (ngSubmit)="onSubmitMotivo()">
                <div class="col-12">
                    <p>Motivo de la pausa</p>
                </div>
                <div class="col-10 offset-1 mb-4">
                    <div class="input-group">
                        <select formControlName="motivo">
                          <option value="null" disabled>Seleccione un motivo de pausa</option>
                          <option *ngFor="let motivo of listPausas" [ngValue]="motivo">{{motivo.pausa}}</option>
                        </select>
                    </div>
                    <div *ngIf="motivoIsSubmitted && motivosForm.get('motivo')!.errors">
                        <div *ngIf="motivosForm.get('motivo')!.errors!.required">
                            <small class="text-danger">Debe seleccionar un motivo de pausa.</small>
                        </div>
                    </div>
                </div>

                <div class="row mx-auto">
                    <div class="col-12 text-center">
                        <button type="button" class="btn-color" type="submit">PAUSAR ATENCIÓN</button>
                    </div>
                </div>
            </form>
            <div class="col-12 mt-4">
                <a type="button" (click)="cerrar()">Volver</a>
            </div>
        </div>
    </div>
</div>
